import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "components/app/dialog/dialog";
import { Button } from "components/ui/button";
import { Input } from "components/ui/input";
import { X } from "lucide-react";

import { useEffect, useState } from "react";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";

interface DialogProps {
  userProfileDetail: any;
  setUserProfileDetail: (value: any) => void;
  isDialogOpen: boolean;
  setIsDialogOpen: (value: boolean) => void;
}

export default function DailogFacebook({ userProfileDetail, setUserProfileDetail, isDialogOpen, setIsDialogOpen }: DialogProps) {
  const [textInput, setTextInput] = useState<string>(userProfileDetail.user.marital_status);
  const { token } = useAppSelector((state) => state.auth);

  const submitProfileApi = async () => {
    try {
      const url = `${RouteApi.submitUpdateUserFacebookLink}token=${token}`;
      const data = {
        facebook_link: textInput,
      };

      const response = await RequestApi(url, { data });

      if (response.status === "success") {
        const updateUser = {
          ...userProfileDetail.user,
          facebook_link: response.user.facebook_link,
        };

        localStorage.setItem("user", JSON.stringify(response.user));

        setUserProfileDetail((prevState: any) => ({
          ...prevState,
          user: updateUser,
        }));
      }
    } catch (error) {
      AppLog.show({
        message: `[submitProfileApi]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const handleSave = () => {
    if (textInput !== userProfileDetail.user.facebook_link) {
      submitProfileApi();
    }
    setIsDialogOpen(false);
  };

  useEffect(() => {
    setTextInput(userProfileDetail.user.facebook_link);
  }, [userProfileDetail.user.facebook_link]);

  return (
    <Dialog open={isDialogOpen}>
      <DialogContent isShowBtnXClose={false} className="custom-dialog-class">
        <DialogHeader>
          <DialogTitle>Edit Facebook</DialogTitle>
          <DialogDescription>Make changes to your profile here. Click save when you're done.</DialogDescription>
          <div
            className="absolute flex items-center justify-center right-4 top-1 z-40 cursor-pointer rounded-full bg-gray-200 dark:bg-accent w-[28px] h-[28px]"
            onClick={() => setIsDialogOpen(false)}
          >
            <X />
          </div>
        </DialogHeader>
        <div>
          <Input
            defaultValue={userProfileDetail.user.facebook_link}
            onChange={(event) => setTextInput(event?.target.value)}
            aria-label="Edit Facebook"
            placeholder="Enter your facebook"
          />
        </div>
        <DialogFooter>
          <Button className="bg-destructive text-white bg-blue-600 hover:bg-blue-500" onClick={handleSave}>
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
